import { render, staticRenderFns } from "./AssessmentDetail.vue?vue&type=template&id=a92d6f96&scoped=true&"
import script from "./AssessmentDetail.vue?vue&type=script&lang=js&"
export * from "./AssessmentDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentDetail.vue?vue&type=style&index=0&id=a92d6f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a92d6f96",
  null
  
)

export default component.exports